var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"box"}},[_c('canvas',{attrs:{"id":"canvas"}},[_c('p',[_vm._v("your browser doesn't support canvas.")])]),_c('div',{attrs:{"id":"stars"}}),_c('div',{attrs:{"id":"stars2"}}),_c('div',{attrs:{"id":"stars3"}})])
}]

export { render, staticRenderFns }